import { Dispatch, SetStateAction } from 'react'
import { DestinationOption, TermData } from '../constants'

export const getDestinationOptions = (
  setSelectedOption: Dispatch<SetStateAction<string>>,
  featuredNonUsTermData: TermData[]
): {
  US_DESTINATION_OPTIONS: DestinationOption[]
  NON_US_DESTINATION_OPTIONS: DestinationOption[]
} => {
  const US_DESTINATION_OPTIONS = [
    {
      id: 'featured-us',
      title: 'Featured',
      linkUrl: '/united-states/',
      linkText: 'Best Rehabs in the United States',
      location: 'United States',
      onClick: () => {
        setSelectedOption(US_DESTINATION_OPTIONS[0].id)
      }
    },
    {
      id: 'california',
      title: 'California',
      linkUrl: '/california/',
      linkText: 'Rehabs in California',
      location: 'California',
      onClick: () => {
        setSelectedOption(US_DESTINATION_OPTIONS[1].id)
      }
    },
    {
      id: 'florida',
      title: 'Florida',
      linkUrl: '/florida/',
      linkText: 'Rehabs in Florida',
      location: 'Florida',
      onClick: () => {
        setSelectedOption(US_DESTINATION_OPTIONS[2].id)
      }
    },
    {
      id: 'global-us',
      title: 'Global',
      linkUrl: '/browse/',
      linkText: 'Best Rehabs Worldwide',
      linkRel: 'nofollow',
      location: '',
      termData: [
        { type: 'NOT locations', title: 'United States' },
        { type: 'NOT locations', title: 'Canada' }
      ],
      onClick: () => {
        setSelectedOption(US_DESTINATION_OPTIONS[3].id)
      }
    }
  ]

  const NON_US_DESTINATION_OPTIONS = [
    {
      id: 'featured-non-us',
      title: 'Featured',
      linkUrl: '/luxury/',
      linkText: 'Best Rehabs in the World',
      location: '',
      termData: featuredNonUsTermData,
      onClick: () => {
        setSelectedOption(NON_US_DESTINATION_OPTIONS[0].id)
      }
    },
    {
      id: 'asia',
      title: 'Asia',
      linkUrl: '/asia/',
      linkText: 'Rehabs in Asia',
      location: 'Asia',
      onClick: () => {
        setSelectedOption(NON_US_DESTINATION_OPTIONS[1].id)
      }
    },
    {
      id: 'europe',
      title: 'Europe',
      linkUrl: '/europe/',
      linkText: 'Rehabs in Europe',
      location: 'Europe',
      onClick: () => {
        setSelectedOption(NON_US_DESTINATION_OPTIONS[2].id)
      }
    },
    {
      id: 'global-non-us',
      title: 'Global',
      linkUrl: '/browse/',
      linkText: 'Best Rehabs Worldwide',
      linkRel: 'nofollow',
      location: '',
      termData: [{ type: 'NOT locations', title: 'Canada' }],
      onClick: () => {
        setSelectedOption(NON_US_DESTINATION_OPTIONS[3].id)
      }
    }
  ]

  return { US_DESTINATION_OPTIONS, NON_US_DESTINATION_OPTIONS }
}
